import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Header, Label, Button, Input, Dropdown } from 'semantic-ui-react';

import { Field, reduxForm, getFormValues } from 'redux-form';
import * as formHelpers from '../../scripts/formHelpers';
import * as formValidators from '../../scripts/formValidators';
import { connect } from 'react-redux';
import {
  MotifButton,
  MotifFormField,
  MotifInput,
  MotifLabel,
  MotifSelect,
  MotifOption,
  MotifModal,
  MotifIcon,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
} from '@ey-xd/motif-react';
import { addAttribute } from '../../common/Attribute';

const SignoffChecklistModal = ({
  showSignoffChecklistModal,
  handleSubmit,
  handleSignoffChecklist,
  toggleShowSignoffChecklistModal,
  gridCurrentState,
}) => {
  const HeaderWrapper = ({ children }) => (
    <div
      style={{
        display: 'flex',
        alignItems: 'start',
        justifyContent: 'center',
      }}
    >
      {children}
    </div>
  );

  const closeButtonProps = {
    title: 'Close Sign-Off checklist modal',
    ariaLabel: 'Close Sign-Off checklist modal',
    dataTestid: 'close',
  };

  useEffect(() => {
    //Add Attribute(type=button) to all button elements having attribute(role = 'combobox')
    addAttribute("button[role = 'combobox']", 'type', 'button');
  });

  return (
    <MotifModal
      variant="alt"
      show={showSignoffChecklistModal}
      onClose={() => toggleShowSignoffChecklistModal()}
      data-testid="SignoffChecklists"
    >
      <MotifModalHeader closeButtonProps={closeButtonProps}>
        <HeaderWrapper>
          <span className="ml-2">Sign-Off Checklist(s)</span>
        </HeaderWrapper>
      </MotifModalHeader>

      <MotifModalBody>
        <form onSubmit={handleSubmit} className="auth">
          <span className="checklistActionMsg">
            You selected{' '}
            {gridCurrentState &&
              new Set(
                gridCurrentState
                  .filter((record) => record.checklistSelection)
                  .map(
                    (record) => record.checklistID + '_' + record.checklistType
                  )
              ).size}{' '}
            checklist(s).
          </span>
          <br />
        </form>
      </MotifModalBody>

      <MotifModalFooter>
        <MotifButton
          variant="secondary"
          type="button"
          onClick={() => toggleShowSignoffChecklistModal()}
          className="right"
          data-testid="Cancel"
        >
          Cancel
        </MotifButton>
        <MotifButton
          type="button"
          onClick={() => handleSignoffChecklist()}
          className="right"
          data-testid="Submit"
        >
          Submit
        </MotifButton>
      </MotifModalFooter>
    </MotifModal>
  );
};

SignoffChecklistModal.propTypes = {
  showSignoffChecklistModal: PropTypes.bool,
  handleSubmit: PropTypes.func,
  toggleShowSignoffChecklistModal: PropTypes.func,
  initialValues: PropTypes.object,
};

export default reduxForm({
  form: 'signoffChecklist',
  enableReinitialize: true,
})(SignoffChecklistModal);
